const uri = (window.location.origin).split('/');

let url = '';
let doc = '';
let contrats = '';
let gRecaptchaCle = '6LeQaEUsAAAAAEmoKFYkBiwBz6oi8lcDRjgDhekY';

if (process.env.NODE_ENV === 'production' && uri[2].match('test')) {  //test-api.servicepostal.com
	url = 'https://core-api-test.servicepostal.com';
	doc = 'https://docs-test.servicepostal.com/';
	contrats = 'https://test.servicepostal.com/envoyer-lettre-en-ligne/GenerateAndSendBusinessContract';
} else if (process.env.NODE_ENV === 'production' && !uri[2].match('test')) { //api.servicepostal.com
	url = 	'https://core-api.servicepostal.com'; // 'beanstalk';
	doc =  	'https://docs.servicepostal.com/'
	contrats = 'https://www.servicepostal.com/envoyer-lettre-en-ligne/GenerateAndSendBusinessContract';
	gRecaptchaCle = '6LcncUwsAAAAAFp9SzvW_LuePAl7XidKWnWxO1RM';
} else if(process.env.NODE_ENV === 'development') {
	url = 	'https://core-api-test.servicepostal.com'
	doc = 	'https://docs-test.servicepostal.com/'
	contrats = 'https://test.servicepostal.com/envoyer-lettre-en-ligne/GenerateAndSendBusinessContract';
} else {
	url = 	'https://core-api-test.servicepostal.com';
	doc =   'https://docs-test.servicepostal.com/'
	contrats = 'https://test.servicepostal.com/envoyer-lettre-en-ligne/GenerateAndSendBusinessContract';
}

export const API_URL = url;
export const DOC_URL = doc;
export const CONTRATS_URL = contrats;
export const GRECAPTCHA_CLE = gRecaptchaCle;



